<template>
  <new-tree
      node-key="id"
      :props="treeProps"
      :data="treeData"
      ref="tree"
      lazy
      :expand-on-click-node="false"
      :load="loadNode"
      :default-expanded-keys="[rootNode.id]"
      :current-node-key="rootNode.id"
      @node-click="handleNodeClick"
  ></new-tree>
</template>
<script>
  import NewTree from "@/components/real-new-tree";
  import orgApi from "@/apis/org";

  export default {
    name: "org-tree",
    components: {NewTree},
    data() {
      return {
        treeProps: {
          label: 'name',
          children: 'childs',
          isLeaf: i => !i.isChild,
        },
        treeData: [],
        rootNode: {
          id: 0,
          name: "总公司",
        },
        currentNode: null,
      };
    },
    methods: {
      getTree(pId) {
        return orgApi.getDepartmentTree(pId);
      },
      loadNode(node, resolve) {
        this.currentNode = node;
        if (node.level == 0) {
          resolve([this.rootNode]);
        } else {
          this.getTree(node.data.id).then((res) => {
            if (res.length > 0) {
              node.isLeaf = false;
            }
            resolve(res);
          });
        }
      },
      handleNodeClick(node) {
        this.$emit("select-node", node);
      },
    },
  };
</script>
